import { Button, Col, Form, Row } from 'antd';
import { cloneDeep, isEmpty } from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputDate, FormInputMobile, FormRadioButton, FormSelect, FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE, VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import {
  BENEFICIARY_SEARCH_OPTION, BENEFICIARY_SEARCH_WITHOUT_POLICY, BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID, BENEFICIARY_SEARCH_OPTION_COI,
  BENEFICIARY_SEARCH_WITH_POLICYNAME, DEFAULT_ADMISSION_FORM_VALUE,
  BENEFICIARY_SEARCH_WITH_CORPORATENAME, BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO, BENEFICIARY_SEARCH_OPTION_ABHI,
  BENEFICIARY_SEARCH_WITH_ONLY_CLIENTID,
  CLEAR_IHAVE_FOR,
  DIFF_POLICY_OPTIONS_FOR,
  CORPRATE_NAME_REGEX,
  POLICY_TYPE_OPTIONS,
} from '../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../store';
import * as actions from '../../../../../../store/actions/newAdmissionAction';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import { centeredNotification, formatName } from '../../../../../../utils/utility';
import moment from 'moment';
import { findKeyValuePair, getPayerConfigPropValue, getPolicyNoPattern, memberIdValidation, memberIdValidationNivaBupa,
  otherPolicyValidation,
  patientNameValidation,
  prefillPolicyType} from '../../../service/crmUtils';

const RPABeneficiarySearchPanel = (props: any): ReactElement => {
  const { form, isLoading, benefFormOrigin } = props;
  const defaultForm = Form.useForm();
  const [benefForm] = benefFormOrigin ? [benefFormOrigin] : defaultForm;
  const [selectedBenefSearch, setSelectedBenefSearch] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [insurerFields, setInsurerFields] = useState<boolean>(false);
  const [retailOptionsCMSGI, setRetailOptionsCMSGI] = useState<boolean>(true);
  const [insurerBajajFields, setInsurerBajajFields] = useState<boolean>(false);
  const [showCorporateName, setCorporateName] = useState<boolean>(false);
  const [showBajajCorporateName, setBajajCorporateName] = useState<boolean>(false);
  const [corporateOptionMDSV, setCorporateOptionMDSV] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [enableRadio, setEnableRadio] = useState('employeeId');
  const [enableFirstRadio, setEnableFirstRadio] = useState('medicalId');
  const [requiredField, setRequiredField] = useState('employeeId');
  const [mandatoryFields, setMandatoryFields] = useState('policyNumber');
  const [isCertificateNoReq, setIsCertificateNoReq] = useState<boolean>(false);
  const [isShowPolicyNo, setIsShowPolicyNo] = useState<boolean>(false);
  const { payer: { isClaimCreationBlockedWithoutBenef, isBenefSearchEnabled, uniqueIdentifier, shortName,
    name: payerName, value: payerValue } }
    = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { payerLookUp }: any = useSelector((state: RootState): RootState => state);
  const commonDetails = { loading, benefForm, isLoading };
  const formControlConfig = useSelector((state: RootState): any => state?.payerList?.formControlConfig || {});
  const payerConfigValues = Object.values(formControlConfig);
  const isOnlyMemberIdBenefField = Boolean(payerConfigValues?.some(({ type, hidden }: any): boolean =>
  type === 'ONLY_MEMBER_ID_BENEF_FIELD' && !hidden));
  const max = payerConfigValues?.filter(({ label, MAX }: any): boolean => label === 'CORPORATE_NAME' && MAX);
  const maximumValue = (max?.map((ele: any): any => ele?.MAX)?.length > 0) ? max?.map((ele: any): any => ele?.MAX) : false;
  const fieldLength = maximumValue ? max?.map((ele: any): any => ele?.maximumLength) : null;
  const minPropObj = payerConfigValues?.filter(({ MIN }: any): boolean => MIN);
  const isPolicyNoPatternCheckRequired =
    Boolean(payerConfigValues?.filter(({ checkPolicyNoPattern, hidden }: any): boolean =>
      checkPolicyNoPattern === true && !hidden)?.length);
  const { selectedPatientDetail} = useSelector((state: RootState): any => state.hospital);
  const { selectedPolicyDetail, memberName} = useSelector((state: RootState): NHCXState => state.nhcx);

  const onSearchChange = (value: any): void => {
    // reseting fields onchange of beneficiary search options
    if (shortName !== 'CMSGI' && shortName !== 'MDSV' && shortName !== 'HERITAGE' && shortName !== 'PHSI') {
      benefForm.resetFields(['mobile', 'policyType']);
    }
    if (shortName === 'ICICI' && value !== 'Member ID' && value !== 'Policy No.') {
      setIsShowPolicyNo(true);
    } else {
      setIsShowPolicyNo(false);
    }
    setInsurerBajajFields(false);
    setBajajCorporateName(false);
    setSelectedBenefSearch(shortName === 'CARE' && value === 'Client ID' ? 'Member ID' : value);
    dispatch(actions.getSelectedSearchType(value));
  };
  const validateFields = (): any => {
    setTimeout((): any => {
      benefForm
        ?.validateFields()
        .then((): any => {
          setDisable(true);
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisable(false);
          }
        });
    }, 200);
  };

  const onClickSearch = (formVal: any): void => {
    initiateMemberForm();
    dispatch(actions.setSelectedCardIndex(-1));

    const newAdminssionSearchVal = {
      ...formVal,
      fullName: formVal?.patientName || '',
      payer: payerName,
    };

    form?.resetFields();
    if (Object.keys(formVal).length) {
      setLoading(true);
      dispatch(actions.setNewAdminssionSearchVal(newAdminssionSearchVal));
      dispatch(actions.benefSearch(formVal, updateBeneficiaryList, failedBeneficiarySearch));
    }
  };

  const initiateMemberForm = (): void => {
    dispatch(actions.sethospDetailsForRoomType({}));
    dispatch(actions.setBeneficiaryList([]));
    dispatch(actions.setIsShowAdmissionForm(false));
    dispatch(actions.setSelectedBeneficiary(null));
    dispatch(actions.setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(actions.setUploadedFiles([]));
    dispatch(actions.setIsAbhaVerified(false, {}));
    dispatch(actions.setHospitalOtherRoomType(''));
  };

  useEffect((): void => {
    benefForm.setFieldsValue({ 'iHave': '' });
  }, []);

  useEffect((): any => {
    checkRequiredField();
  }, [benefForm.getFieldsValue('iHave'), benefForm.getFieldsValue('policyType')]);
  useEffect((): void => {
    const selectedValue =
      isBenefSearchEnabled ?
        ('')
        : '';
    benefForm.setFieldsValue({
      'iHave': selectedValue,
      Payer: payerValue,
      policyNumber: '',
      corporateName: '',
      memberId: '',
      patientName: '',
      employeeId: '',
      insurerName: [],
      policyType: [],
      policyName: '',
      status: '',
      mobile: '',
    });
    setInsurerFields(false);
    setSelectedBenefSearch(selectedValue);
  }, [payerName]);

  useEffect((): any => {
    if (!isEmpty(selectedPatientDetail)) { // set val
      const patientDetails = selectedPatientDetail?.patientDetails;
      const treatmentDetails = selectedPatientDetail?.treatmentDetails;
      benefForm?.setFieldsValue(patientDetails || selectedPatientDetail);
      if (patientDetails?.insurerName) {
        benefForm?.setFieldsValue({ insurerName: undefined });
      }
      if (treatmentDetails?.dateOfAdmission) {
        const dateOfAdmission = treatmentDetails?.dateOfAdmission;
        // must use moment here as it uses the old datePicker
        if (dateOfAdmission && moment(dateOfAdmission).isValid()) {
          benefForm?.setFieldsValue({dateOfAdmission: moment(dateOfAdmission)});
        }
      }
      benefForm?.setFieldsValue(
        { patientName: formatName(selectedPatientDetail?.memberName || patientDetails?.patientName) });
      // prefill PolicyType
      const policyOptions = DIFF_POLICY_OPTIONS_FOR.includes(shortName) ?
      POLICY_TYPE_OPTIONS.CUSTOMER_TYPES : POLICY_TYPE_OPTIONS.SECTOR_TYPES;
      patientDetails?.policyType && prefillPolicyType(patientDetails?.policyType, policyOptions, benefForm);
    }
    if (!isEmpty(selectedPolicyDetail)) {
      benefForm?.setFieldsValue({ memberId: selectedPolicyDetail?.memberId });
      benefForm?.setFieldsValue({ patientName: memberName });
      benefForm?.setFieldsValue({ policyNumber: selectedPolicyDetail?.productId?.split('|')[1]});
    }
  }, [selectedPatientDetail, selectedPolicyDetail, payerValue]);

  const updateBeneficiaryList = (benefList: any[]): void => {
    setLoading(false);
    dispatch(actions.setBeneficiaryList(benefList));
  };

  const failedBeneficiarySearch = (errorMsg: string, allowNextStage: any, errorResponse: any): void => {
    if (errorResponse === 'Bad Gateway') { // checking for 502 error
      centeredNotification('Details not found , Please submit a claim on IHX');
    } else {
      if (!errorResponse) {
        centeredNotification(errorMsg);
      }
    }
    let enableManual = false;
    setLoading(false);
    if (!isClaimCreationBlockedWithoutBenef) { // disabling claim creation when the flag is true irrespective of the allowNext stage
      enableManual = String(allowNextStage)?.toUpperCase() !== 'NO';
  } //   IPP-3655
    if (enableManual) {
      dispatch(actions.enableManualSubmission());
      enableAdmissionForm();
    }
  };

  const enableAdmissionForm = (): void => {
    dispatch(actions.setIsShowAdmissionForm(true));
    dispatch(actions.setSelectedBeneficiary(null));
  };
  const commonDetail = { form: benefForm };

  const onInsurerNameChange = (selectedInsurer: any): any => {
    if (selectedInsurer) {
      const { payerMasterValue: insurerId } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', selectedInsurer) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', selectedInsurer) ||
        {};
      dispatch(actions.setInsurerID(insurerId));
    }
  };
  const onCorporateNameChange = (selectedCorporate: any): any => {
    if (selectedCorporate) {
      const { payerMasterValue: corporateName } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.corporate_name, 'name', selectedCorporate) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.corporate_name, 'value', selectedCorporate) ||
        {};
      dispatch(actions.setCorporateName(corporateName));
    }
  };
  const onSelectRadio = (event: any): any => {
    if (event?.target?.value === 'Employee ID') {
      setEnableRadio('employeeId');
    } else {
      setEnableRadio('corporateName');
    }
  };
  const onSelectFirstRadio = (event: any): any => {
    if (event?.target?.value === 'Member ID') {
      setEnableFirstRadio('medicalId');
    } else {
      setEnableFirstRadio('policyNumber');
    }
  };
  const clearIHave = (): void => {
    benefForm?.setFieldsValue({ 'iHave' : '' });
    setSelectedBenefSearch('');
  };
  const updateFields = (): any => {
    const { policyType } = benefForm?.getFieldsValue(['policyType']);
    if (CLEAR_IHAVE_FOR.includes(shortName)) {
      clearIHave();
    }
    if (policyType === 'Retail') {
      setCorporateOptionMDSV(false);
      setRetailOptionsCMSGI(true);
      setInsurerFields(true);
      setCorporateName(false);
    } else if (policyType === 'Corporate' && shortName === 'CMSGI') {
      setRetailOptionsCMSGI(false);
      setCorporateName(true);
      setInsurerFields(false);
    } else if (policyType === 'Corporate' && shortName === 'MDSV') {
      setCorporateOptionMDSV(true);
    } else if ((shortName === 'HERITAGE' || shortName === 'PHSI') && policyType === 'Corporate') {
        setCorporateName(true);
        setInsurerFields(false);
    }
  };

  // for showing the policy no, emp id, mobile no fields for bajaj
  const bajajFields = (): any => {
    const { policyType } = benefForm?.getFieldsValue(['policyType']);
    if (policyType) {
      setInsurerBajajFields(true);
      setBajajCorporateName(false);
    }
    if (policyType === 'Group') {
      setBajajCorporateName(true);
    }
  };

  // for making the employee id and mobile no field optional
  const checkRequiredField = (): any => {
    const { employeeId, mobile, policyNumber } = benefForm.getFieldsValue(['employeeId', 'mobile', 'policyNumber']);
    if (shortName === 'Bajaj') {
      if (employeeId && !mobile) {
        setRequiredField('employeeId');
      } else if (!employeeId && mobile && mobile.slice(3).trim().length > 0) {
        setRequiredField('mobile');
      } else {
        setRequiredField('employeeId');
      }
    }
    if (isPolicyNoPatternCheckRequired && policyNumber) {
      setIsCertificateNoReq(getPolicyNoPattern(policyNumber || ''));
    }
  };

  // for making the insurance card number and policy no field optional
  const checkMandatoryFields = (): any => {
    if (shortName === 'PHSI') {
      const { insuranceCardNumber, policyNumber } = benefForm.getFieldsValue(['insuranceCardNumber', 'policyNumber']);
      if (insuranceCardNumber && !policyNumber) {
        setMandatoryFields('insuranceCardNumber');
      } else if (!insuranceCardNumber && policyNumber) {
        setMandatoryFields('policyNumber');
      } else {
        setMandatoryFields('policyNumber');
      }
    }
  };
  const getSearchUI = (): (ReactElement | null) => {
    if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[0] || selectedBenefSearch === BENEFICIARY_SEARCH_WITH_CORPORATENAME[0]) {
      return <React.Fragment>
        <FormTextInput detail={{
          ...commonDetail, key: 'memberId', size: 12, isLoading,
          rules: shortName === 'PHSI' ? [memberIdValidation] : shortName === 'NIVA BUPA' ? [memberIdValidationNivaBupa] : [],
          minLengthValue: getPayerConfigPropValue(minPropObj, 'MIN', 'memberId'),
          fieldLengthValue: [getPayerConfigPropValue(minPropObj, 'minimumLength', 'memberId')],
        }} />
        {(shortName === 'NIVA BUPA') &&
          <FormSelect detail={{
            ...commonDetail,
            key: 'policyType',
            size: 12,
            allowClear: true,
            required: true,
            hidden: false,
            label: 'Select Policy Type',
            placeholder: 'Select',
            options: POLICY_TYPE_OPTIONS.CUSTOMER_TYPES,
            onChange: bajajFields,
          }} />}
        {(shortName === 'SHAI' || (shortName === 'NIVA BUPA' && showBajajCorporateName) || shortName === 'MDSV' || shortName === 'HERITAGE')
          &&
          <FormTextInput detail={{
            ...commonDetail, key: 'patientName', label: 'Patient Name',
            smallLabel : '(Full Name as per Member Card / Policy)', size: 12, isLoading, isName: true,
            isMaxLengthNotApplicable : true,
            rules: [
              {required: true,
              message: 'Patient Name is required!',
              },
              {max: 50,
              message: 'Patient Name cannot be longer than 50 Characters'},
              ...(shortName === 'NIVA BUPA' ? [patientNameValidation] : [])]          }} />}
        {(shortName === 'CARE') && <FormInputDate detail={{
          ...commonDetail,
          key: 'dateOfAdmission',
          size: 12,
        }} />}
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[1]) {
      return <React.Fragment>
        {(shortName === 'SHAI') &&
          <>
            <FormRadioButton detail={{
              ...commonDetail,
              key: 'employeeCorporateBeneficiaryRadio',
              size: 10,
              options: ['Employee ID', 'Corporate Name'],
              onChange: onSelectRadio,
              defaultValue: 'Employee ID',
              defaultChecked: true,
            }} />
            <FormRadioButton detail={{
              ...commonDetail,
              key: 'medicalPolicyBeneficiaryRadio',
              size: 10,
              options: ['Member ID', 'Policy No'],
              onChange: onSelectFirstRadio,
              defaultValue: 'Member ID',
              defaultChecked: true,
            }} />
            <FormTextInput detail={{ ...commonDetail, key: 'patientName',
            label: 'Patient Name',
            smallLabel : '(Full Name as per Member Card / Policy)', size: 10, isLoading, isName: true,
            isMaxLengthNotApplicable : true,
            rules: [{ required: true, message: 'Patient Name is required!' }, {max: 50,
              message: 'Patient Name cannot be longer than 50 Characters'}],
            }} /></>
        }
        {(shortName === 'SHAI') ? (
          enableRadio === 'employeeId' ?
            <FormTextInput detail={{
              ...commonDetail, key: 'employeeId', size: 8,
              required: true, isLoading, regex: /[^a-zA-Z\d\-]*/gm,
            }} />
            : enableRadio === 'corporateName' &&
            <FormTextInput detail={{
              ...commonDetail, key: 'corporateName', size: 10, required: true, isLoading, maxLengthValue: maximumValue,
              fieldLengthValue: fieldLength,
              ...({ regex: CORPRATE_NAME_REGEX }),
            }} />
        ) : !insurerFields && shortName !== 'ICICI' &&
        <><FormTextInput detail={{
          ...commonDetail, key: 'employeeId', size: 8,
          required: true, isLoading, regex: /[^a-zA-Z\d\-]*/gm,
        }} />
          {shortName !== 'CMSGI' && shortName !== 'HERITAGE' &&
            <FormTextInput detail={{
              ...commonDetail, key: 'corporateName', size: 10, required: true, isLoading, maxLengthValue: maximumValue,
              fieldLengthValue: fieldLength,
              ...({ regex: CORPRATE_NAME_REGEX}),
            }} />
          }</>
        }
        {(shortName === 'SHAI') &&
          enableFirstRadio === 'medicalId' ?
          <FormTextInput detail={{ ...commonDetail, key: 'memberId', size: 8, isLoading }} /> :
          enableFirstRadio === 'policyNumber' &&
          <FormTextInput detail={{
            ...commonDetail,
            key: 'policyNumber',
            size: 8,
            labelClass: 'mb-0',
            required: true,
            rules: [otherPolicyValidation],
          }} />}
        {(shortName === 'PHSI' || shortName === 'HERITAGE') &&
          <>
            {insurerFields &&
              <><FormTextInput detail={{
                ...commonDetail,
                key: 'insuranceCardNumber',
                size: 8,
                labelClass: 'mb-0',
                required: (mandatoryFields === 'insuranceCardNumber'),
                onChange: checkMandatoryFields,
              }} /><FormTextInput detail={{
                ...commonDetail,
                key: 'policyNumber',
                size: 8,
                labelClass: 'mb-0',
                required: (mandatoryFields === 'policyNumber'),
                onChange: checkMandatoryFields,
                rules: [otherPolicyValidation],
              }} />
                <FormSelect detail={{
                  ...commonDetail,
                  key: 'insurerName',
                  size: 10,
                  options: (payerLookUp[uniqueIdentifier]?.insurerName || []),
                  showSearch: true,
                  required: true,
                  onChange: onInsurerNameChange,
                }} /></>
            } {
              showCorporateName &&
              <>
                <FormSelect detail={{
                  ...commonDetail,
                  key: 'corporateNameDropdown',
                  size: 12,
                  options: (payerLookUp[uniqueIdentifier]?.corporate_name || []),
                  showSearch: true,
                  required: true,
                  onChange: onCorporateNameChange,
                }} /></>
            }
          </>
        }
        {(shortName === 'ICICI') && (
          <><FormTextInput detail={{
            ...commonDetail, key: 'employeeId', size: 8,
            required: true, isLoading, regex: /[^a-zA-Z\d\-]*/gm,
          }} />
          <FormTextInput detail={{ ...commonDetail, key: 'patientName', label: 'Patient Name', smallLabel : '(Full Name as per Member Card / Policy)',
           size: 10, isLoading, isName: true, isMaxLengthNotApplicable : true,
           rules: [{ required: true, message: 'Patient Name is required!'}, {max: 50,
           message: 'Patient Name cannot be longer than 50 Characters'}]}} /></>
        )}
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[2]) { // policy type for bajaj
      return <React.Fragment>
        {(shortName === 'Bajaj') &&
          <FormSelect detail={{
            ...commonDetail,
            key: 'policyType',
            size: 12,
            allowClear: true,
            required: true,
            hidden: false,
            label: 'Select Policy Type',
            placeholder: 'Select',
            options: POLICY_TYPE_OPTIONS.CUSTOMER_TYPES,
            onChange: bajajFields,
          }} />
        }
        {/* policy number fields to be visible only bajaj and star */}
        {((insurerBajajFields || (shortName === 'SHAI') || (shortName === 'NIVA BUPA')) || (shortName === 'CMSGI')
          || (shortName === 'ICICI') || (shortName === 'MDSV') || (shortName === 'HERITAGE') || (shortName === 'VIDAL') || (shortName === 'PHSI')) &&
          <><FormTextInput detail={{
            ...commonDetail,
            key: 'policyNumber',
            size: 12,
            isLoading,
            onChange: checkRequiredField,
            rules: [otherPolicyValidation],
            minLengthValue: getPayerConfigPropValue(minPropObj, 'MIN', 'policyNumber'),
            fieldLengthValue: [getPayerConfigPropValue(minPropObj, 'minimumLength', 'policyNumber')],
            isName: false,
          }} /></>}
        {/* employee id and mobile fields for bajaj */}
        {((shortName === 'Bajaj') && showBajajCorporateName) || (corporateOptionMDSV) &&
          <><FormTextInput detail={{
            ...commonDetail, key: 'employeeId', size: 12,
            required: (requiredField === 'employeeId'), isLoading, regex: /[^a-zA-Z\d\-]*/gm, onChange: checkRequiredField,
        }} />
          {(!corporateOptionMDSV) &&
            <FormInputMobile detail={{
              ...commonDetail,
              key: 'mobile',
              size: 12,
              required: (requiredField === 'mobile'),
              onChange: checkRequiredField,
              rightFooterText: null,
            }} />}</>}
        {
          (shortName !== 'Bajaj') && (shortName !== 'NIVA BUPA') && (shortName !== 'CMSGI') && <>
            <FormTextInput detail=
              {{ ...commonDetail, key: 'patientName', label: 'Patient Name', smallLabel : '(Full Name as per Member Card / Policy)',
               size: 12, isLoading, isName: true, isMaxLengthNotApplicable : true,
               rules: [{ required: true, message: 'Patient Name is required!' }, {max: 50,
                message: 'Patient Name cannot be longer than 50 Characters'}] }} /></>
        }
        {(shortName === 'NIVA BUPA') &&
          <FormSelect detail={{
            ...commonDetail,
            key: 'policyType',
            size: 12,
            allowClear: true,
            required: true,
            hidden: false,
            label: 'Select Policy Type',
            placeholder: 'Select',
            options: POLICY_TYPE_OPTIONS.CUSTOMER_TYPES,
            onChange: bajajFields,
          }} />}
        {
          (showBajajCorporateName && shortName === 'NIVA BUPA') &&
          <FormTextInput
            detail={{
              ...commonDetail,
              key: 'patientName',
              label: 'Patient Name',
              smallLabel : '(Full Name as per Member Card / Policy)',
              size: 10,
              isLoading,
              isName: true,
              isMaxLengthNotApplicable : true,
              rules: [
                {required: true,
                message: 'Patient Name is required!',
                },
                {max: 50,
                message: 'Patient Name cannot be longer than 50 CSharacters'},
                ...(shortName === 'NIVA BUPA' ? [patientNameValidation] : [])],
              }}
          />
        }
        {/* Show certificate number field only when Policy No pattern is matched */}
        {isCertificateNoReq &&
          <FormTextInput detail={{
            ...commonDetail,
            key: 'certificateNumber',
            size: 12,
            required: true,
          }} />
        }
        {(insurerFields && shortName === 'PHSI') &&
          <>
            <FormSelect detail={{
              ...commonDetail,
              key: 'insurerName',
              size: 10,
              options: (payerLookUp[uniqueIdentifier]?.insurerName || []),
              showSearch: true,
              required: true,
              onChange: onInsurerNameChange,
            }} />
          </>
        }
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_WITH_POLICYNAME[3]) {
      return <React.Fragment>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'policyName',
          size: 12,
          isLoading,
          isName: true,
        }} />
        <FormTextInput detail={{
          ...commonDetail, key: 'employeeId', size: 8,
          required: (requiredField === 'employeeId'), isLoading, regex: /[^a-zA-Z\d\-]*/gm, onChange: checkRequiredField,
        }} />
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_WITH_CORPORATENAME[2]) { // corporate name , mobile, employee id fields for bajaj
      return <React.Fragment>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'corporateName',
          size: 12,
          required: true,
          isLoading,
        }} />
        <FormTextInput detail={{
          ...commonDetail, key: 'employeeId', size: 12,
          required: (requiredField === 'employeeId'), isLoading, regex: /[^a-zA-Z\d\-]*/gm, onChange: checkRequiredField,
        }} />
        <FormInputMobile detail={{
          ...commonDetail,
          key: 'mobile',
          size: 12,
          required: (requiredField === 'mobile'),
          onChange: checkRequiredField,
        }} />
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_COI[2]) {
      return <React.Fragment>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'coiNumber',
          size: 12,
          required: true,
          isLoading,
        }} />
         {(shortName === 'NIVA BUPA') &&
          <FormSelect detail={{
            ...commonDetail,
            key: 'policyType',
            size: 12,
            allowClear: true,
            required: true,
            hidden: false,
            label: 'Select Policy Type',
            placeholder: 'Select',
            options: POLICY_TYPE_OPTIONS.CUSTOMER_TYPES,
            onChange: bajajFields,
          }} />}
        {
          showBajajCorporateName &&
          <FormTextInput
            detail={{
              ...commonDetail,
              key: 'patientName',
              size: 10,
              label: 'Patient Name',
              smallLabel : '(Full Name as per Member Card / Policy)',
              isLoading,
              isName: true,
              isMaxLengthNotApplicable : true,
              rules: [
                {required: true,
                message: 'Patient Name is required!'},
                {max: 50,
                message: 'Patient Name cannot be longer than 50 Characters'},
                ...(shortName === 'NIVA BUPA' ? [patientNameValidation] : [])],
            }}
          />
        }
      </React.Fragment>;
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO[2]) { // certificateNumber for Chola
      return <React.Fragment>
        {retailOptionsCMSGI &&
          <FormTextInput detail={{
            ...commonDetail,
            key: 'certificateNumber',
            size: 12,
            required: true,
            isLoading,
          }} />
        }
      </React.Fragment>;
    } else {
      return null;
    }
  };
  const getSearchOption = (): any[] => {
    return (shortName === 'SHAI') ? BENEFICIARY_SEARCH_OPTION :
      (shortName === 'ICICI') ? BENEFICIARY_SEARCH_WITH_POLICYNAME : ((shortName === 'TATA AIG') || isOnlyMemberIdBenefField) ?
        BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID : shortName === 'CARE' ? BENEFICIARY_SEARCH_WITH_ONLY_CLIENTID : (shortName === 'Bajaj') ?
          BENEFICIARY_SEARCH_WITH_CORPORATENAME : (shortName === 'NIVA BUPA') ?
            BENEFICIARY_SEARCH_OPTION_COI : ((shortName === 'CMSGI') && retailOptionsCMSGI) ?
              BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO : (shortName === 'CMSGI') ?
                BENEFICIARY_SEARCH_WITHOUT_POLICY : (shortName === 'MDSV' || (shortName === 'HERITAGE' && !showCorporateName) ||
                  (shortName === 'VIDAL') || (shortName === 'PHSI' && !showCorporateName)) ?
                  BENEFICIARY_SEARCH_OPTION_ABHI : BENEFICIARY_SEARCH_WITHOUT_POLICY;
  };

  return <>
    <Form
      layout="vertical"
      form={benefForm}
      validateMessages={VALIDATE_MESSAGES}
      onFinish={onClickSearch}
      requiredMark="optional"
      onValuesChange={validateFields}
      noValidate={true}>
      <Row gutter={GUTTOR_SPACE}>
        {(shortName === 'FHPL') &&
          <FormSelect detail={{
            ...commonDetail,
            key: 'insurerName',
            size: 12,
            options: (payerLookUp[uniqueIdentifier]?.insurerName || []),
            showSearch: true,
            required: true,
            onChange: onInsurerNameChange,
          }} />
        }
        {((shortName === 'CMSGI') || (shortName === 'MDSV') || (shortName === 'HERITAGE') || (shortName === 'PHSI')) &&
          <><FormSelect detail={{
            ...commonDetail,
            key: 'policyType',
            size: 12,
            showSearch: true,
            required: true,
            options: POLICY_TYPE_OPTIONS.SECTOR_TYPES,
            onChange: updateFields,
          }} />
            {!retailOptionsCMSGI &&
              <FormTextInput detail={{
                ...commonDetail,
                key: 'policyNumber',
                size: 12,
                isLoading,
                rules: [otherPolicyValidation],
                isName: false,
              }} />
            }</>
        }
        <FormSelect
          detail={{
            ...commonDetails,
            size: 12,
            allowClear: false,
            key: 'iHave',
            options: getSearchOption(),
            onChange: onSearchChange,
            required: true,
          }}
        />
        {isShowPolicyNo &&
          <FormTextInput detail={{
            ...commonDetail,
            key: 'policyNumber',
            size: 12,
            isLoading,
            rules: [otherPolicyValidation],
            isName: false,
          }} />
        }
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        {getSearchUI()}
        <Col
         md={24}
         className="text-right"
        >
          <Button
            data-testid="beneficiary-search-button"
            className={`his-next-button
              ${!disable ? 'benef-submit-disabled' : 'benef-submit-btn'}
            `}
            type={!disable ? undefined : 'primary'}
            htmlType="submit"
            loading={loading}
            disabled={!disable}>Search</Button>
        </Col>
      </Row>
    </Form>
  </>;
};

export default RPABeneficiarySearchPanel;
